export const MAIN_ACTIONS_TYPE = {
    CUSTOM_BUTTONS: 'customButtons',
    PRIMARY_AND_SECONDARY_BUTTONS: 'primaryAndSecondaryButtons',
    PRIMARY_AND_THREE_DOTS_BUTTONS: 'primaryAndThreeDotsButtons',
    SIMPLE_BUTTON: 'simpleButton',
    SIMPLE_DROPDOWN_BUTTON: 'simpleDropdownButton',
};
//# sourceMappingURL=constants.js.map